const templatePreview = 'TemplatePreview';

// PREVIEW TEMPLATE
export const PREVIEW_TEMPLATE_REQUEST = `${templatePreview}/PREVIEW_TEMPLATE_REQUEST`;
export const PREVIEW_TEMPLATE_RESPONSE = `${templatePreview}/PREVIEW_TEMPLATE_RESPONSE`;
export const PREVIEW_TEMPLATE_ERROR = `${templatePreview}/PREVIEW_TEMPLATE_ERROR`;

// GET IN-APP CONTENT
export const GET_IN_APP_CONTENT_REQUEST = `${templatePreview}/GET_IN_APP_CONTENT_REQUEST`;
export const GET_IN_APP_CONTENT_RESPONSE = `${templatePreview}/GET_IN_APP_CONTENT_RESPONSE`;
export const GET_IN_APP_CONTENT_ERROR = `${templatePreview}/GET_IN_APP_CONTENT_ERROR`;

// SET PUSH TOGGLE STATE
export const SET_ACTIVE_PUSH_DEVICE_WRAPPER_STATE = `${templatePreview}/SET_ACTIVE_PUSH_DEVICE_WRAPPER_STATE`;
